import api from '../config/api';

const getCartItems = async (userId) => {
  try {
    const response = await api.get(`/cart/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Sepet öğeleri getirme hatası:', error);
    throw error.response?.data?.error || error.message || 'Sepet öğeleri alınırken bir hata oluştu';
  }
};

const addToCart = async (userId, productId, phoneModelId, colorId, quantity = 1) => {
  try {
    const response = await api.post('/cart/add', {
      user_id: userId,
      product_id: productId,
      phone_model_id: phoneModelId,
      color_id: colorId,
      quantity
    });
    return response.data;
  } catch (error) {
    console.error('Sepete ekleme hatası:', error);
    throw error.response?.data?.error || error.message || 'Ürün sepete eklenirken bir hata oluştu';
  }
};

const updateCartItem = async (userId, productId, phoneModelId, colorId, quantity) => {
  try {
    const response = await api.put('/cart/update', {
      user_id: userId,
      product_id: productId,
      phone_model_id: phoneModelId,
      color_id: colorId,
      quantity
    });
    return response.data;
  } catch (error) {
    console.error('Sepet güncelleme hatası:', error);
    throw error.response?.data?.error || error.message || 'Sepet güncellenirken bir hata oluştu';
  }
};

const removeFromCart = async (userId, productId, phoneModelId, colorId) => {
  try {
    const response = await api.delete('/cart/remove', {
      data: {
        user_id: userId,
        product_id: productId,
        phone_model_id: phoneModelId,
        color_id: colorId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Sepetten silme hatası:', error);
    throw error.response?.data?.error || error.message || 'Ürün sepetten silinirken bir hata oluştu';
  }
};

const clearCart = async (userId) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Authentication token not found');
    }

    const response = await api.delete(`/cart/${userId}/clear`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Sepet temizleme hatası:', error);
    throw error.response?.data?.error || error.message || 'Sepet temizlenirken bir hata oluştu';
  }
};

export {
  getCartItems,
  addToCart,
  updateCartItem,
  removeFromCart,
  clearCart
}; 